/** 手动账单 /metering/bill/new-manual-bill（manualBill.vue） */
export default {
  manualBillPage: {
    phDateStart: '开始日期',
    phDateEnd: '结束日期',
    phTenant: '租户名称/编号',
    phBillType: '费用类型',
    phSettleWay: '账单类型',
    phPayType: '付费模式',
    billTypeElectric: '电费',
    billTypeWater: '水费',
    billTypeService: '服务费',
    settleWay1: '手动扣款',
    optPayPrepaid: '预付费',
    optPayPostpaid: '后付费',
    btnSearch: '查询',
    btnReset: '重置',
    btnExport: '导出',
    exportCurrentPage: '导出本页',
    exportSelected: '导出选中',
    exportAll: '导出全部',
    tooltipMeterElec: '表计电费：',
    tooltipOtherElec: '其他电费：',
    tooltipMeterWater: '表计水费：',
    tooltipOtherWater: '其他水费：',
    tooltipTotal: '合计：',
    statOtherElectricity: '其他电费',
    statOtherWater: '其他水费',
    statServiceFee: '服务费',
    statGrandTotal: '合计',
    sectionTitle: '手动扣款账单列表',
    sortDefault: '默认排序',
    selectedLine: '已选择 <span class="count">{count}</span> 条数据',
    payPaid: '已缴费',
    payUnpaid: '未缴费',
    colDetail: '详情',
    btnDetail: '详情',
    shortcut7d: '最近7天',
    shortcut15d: '最近15天',
    shortcut30d: '最近30天',
    shortcutThisMonth: '本月',
    shortcutLastMonth: '上月',
    colRid: '账单编号',
    colOccurDate: '账单日期',
    colCreateDate: '创建日期',
    colTenantInfo: '租户信息',
    colPayType: '付费模式',
    colBillType: '费用类型',
    colSettleWay: '账单类型',
    colBalance: '账单金额',
    colPayStatus: '缴费状态',
    colDiscountAmt: '抵扣金金额（元）',
    colRealAmt: '现金支付（元）',
    colStatus: '开票状态',
    invoice0: '未开票',
    invoice1: '审核中',
    invoice2: '已开票',
    invoice3: '已拒绝',
    msgFetchListFail: '获取数据失败',
    msgFetchBillFail: '获取账单数据失败',
    msgNoDataExport: '暂无数据可导出',
    msgExportFail: '导出失败，请重试',
    msgExportOk: '成功导出{count}条数据！',
    msgExportOkSelected: '成功导出{count}条选中数据！',
    warnNoSelectedExport: '请先勾选要导出的数据',
    successExported: '成功导出 {count} 条数据',
    successExportedLimit: '共 {total} 条，已导出前 {count} 条',
    exporting: '正在导出...',
    exportSheetName: '手动扣款账单',
    filePrefix: '手动扣款账单',
    billTypeUseWater: '水费',
    billTypeUseElectric: '电费',
    billTypeUseService: '服务费'
  }
}
